import React, { useContext } from "react";

import { attributesToCompare } from "../attributesToCompare";
import CameraComparisonContext from "../CameraComparisonContext";
import { CameraGeneralInformation } from "../CameraGeneralInformation/CameraGeneralInformation";

import t from "../../../../lib/translate";

import * as styles from "./comparisonTable.module.less";

export function ComparisonTable() {
    const { selectedCameras } = useContext(CameraComparisonContext);

    return (
        <div className={styles.tableWrapper}>
            <table>
                <tbody>
                    {attributesToCompare.map((attribute) => {
                        const show =
                            attribute === "cameraModel" ||
                            selectedCameras.some(
                                ({ [attribute]: value }) => !!value
                            );

                        if (!show) return null;

                        return (
                            <tr key={`label-${attribute}`}>
                                <td>
                                    {t(
                                        `camera.property.${attribute.toLowerCase()}`
                                    )}
                                </td>

                                {selectedCameras.map(
                                    ({
                                        id,
                                        name,
                                        comparisonImage: image,
                                        [attribute]: value
                                    }) => (
                                        <React.Fragment
                                            key={`${id}-${attribute}`}
                                        >
                                            {attribute === "cameraModel" ? (
                                                <CameraGeneralInformation
                                                    id={id}
                                                    name={name}
                                                    image={image}
                                                />
                                            ) : (
                                                <td>{value}</td>
                                            )}
                                        </React.Fragment>
                                    )
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
